export default __webpack_public_path__ + "static/media/mello_dark_coming_soon.99879615.png";